(function () {
	'use strict';

	angular
		.module('app.setup')
		.controller('featureFlagsConfig', featureFlagsConfig);

	featureFlagsConfig.$inject = [];

	function featureFlagsConfig() {
	}
})();